import { Building2, MapPin } from "lucide-react"
import { ObjectType } from "../../types/types"
import { returnAddressString } from "../../../../services/functions"
import ObjectLocationMap from "./ObjectLocationMap"

type ObjectDetailHeroType = {
    objectData: ObjectType
    customerOfObject: string
}

export default function ObjectDetailHero(props: ObjectDetailHeroType) {
    const address = returnAddressString(props.objectData.adress)

    return (
        <div className="flex w-full min-w-0 flex-col gap-4 md:flex-row md:items-start lg:flex-1">
            <div className="h-48 w-56 shrink-0 lg:h-56 lg:w-72">
                <ObjectLocationMap adress={props.objectData.adress} showLabel={false} heightClass="h-48 lg:h-56" />
            </div>
            <div className="flex min-w-0 flex-1 flex-col justify-start gap-2 pt-1">
                <h2 className="text-xl font-bold leading-tight break-words">{props.objectData.objectIndication || "–"}</h2>
                <div className="flex items-start min-w-0">
                    <MapPin className="w-5 h-5 shrink-0 text-primary mt-0.5" />
                    <p title={address} className="pl-2 text-sm 2xl:text-base break-words">
                        {address}
                    </p>
                </div>
                <div className="flex items-center min-w-0">
                    <Building2 className="w-5 h-5 shrink-0 text-primary" />
                    <p title={props.customerOfObject} className="pl-2 text-sm 2xl:text-base line-clamp-1">
                        {props.customerOfObject || "-"}
                    </p>
                </div>
            </div>
        </div>
    )
}
